import { PASSWORD_RULES } from "config/constants";
import validator from "validator";

export const validateEmail = (email: string) => (validator.isEmail(email) ? "" : "Invalid Email");

export const validateURL = (url: string) => {
  try {
    new URL(url);
    return "";
  } catch (err) {
    // console.error(err);
    return "Invalid URL";
  }
};

export const isURL = (url: string) => !validateURL(url);

export const isPassword = (password: string) => password && validator.isStrongPassword(password);

export const validatePassword = (password: string) => {
  if (isPassword(password)) {
    return "";
  }
  return PASSWORD_RULES;
};
export const validateName = (name: string) => {
  if (!name || typeof name !== "string") {
    return "Name is required";
  }
  if (name?.search(/[^a-zA-Z\s]/) !== -1) {
    return "Name can only include alphabets and spaces.";
  }
  return "";
};

export const validatePositiveFloat = (number: number) => {
  if (number < 0) {
    return "must be positive number.";
  }
  return "";
};

export const comparePasswords = (pass1: string, pass2: string) => (pass1 === pass2 ? "" : "Passwords do not match");
